export interface PageCounterProps {
  n: number;
  onClick?: () => void;
  selected: boolean;
}

export enum PaginationModeType {
  CLIENT = "client",
  SERVER = "server"
}

export type PaginationMode =
  | PaginationModeType.CLIENT
  | PaginationModeType.SERVER;

export interface PaginationProps {
  total: number;
  page: number;
  limit: number;
  enabled?: boolean;
  infinite?: boolean;
  paginationMode?: PaginationMode;
  // Number of rows on the current page, used in "client" mode to decide if Next is enabled
  dataLength?: number;
  columnAction?: () => void;
  setPage: (s: number, isApproved: boolean) => void;
  showOnMobile?: boolean; // New prop to control mobile visibility
  styles?: {
    mobile?: string;
    desktop?: string;
  };
}
